import React from 'react'
import { BarChart3 } from 'lucide-react'
import { StatsCard } from './stats/StatsCard'
import { formatCompactNumber } from '@/utils'
import type { MonthlyAvgDataPoint } from '@/types/otc'
import { buildChartSeries } from './charts/otcSeries'

interface TotalOrdersCardProps {
  totalOrders: number
  loading?: boolean
  monthlyAvg?: MonthlyAvgDataPoint[]
  label?: string
}

const TotalOrdersMiniBarChart: React.FC<{ monthlyAvg?: MonthlyAvgDataPoint[]; seed: number }> = ({ monthlyAvg, seed }) => {
  const heights = buildChartSeries({
    source: monthlyAvg,
    count: 14,
    min: 18,
    max: 100,
    seed,
  })
  const greyHeights = heights.slice(0, 8)
  const limeHeights = heights.slice(8)

  return (
    <div className="relative h-full w-full max-w-[214px]">
      {greyHeights.map((height, index) => (
        <div
          key={`grey-${index}`}
          className="absolute bottom-0 bg-gradient-to-b from-[rgba(197,204,159,0.32)] to-transparent border-t-2 border-[#cccdc5]"
          style={{
            left: `${index * 13.75}px`,
            width: '13.75px',
            height: `${height}px`,
          }}
        />
      ))}

      {limeHeights.map((height, index) => {
        const left = index === 0 ? 110 : 110 + index * 17
        const width = index === 1 || index === 4 ? 18 : 17
        const frameHeight = Math.max(24, Math.round(height * 0.6))

        return (
        <div
          key={`lime-${index}`}
          className="absolute bottom-0"
          style={{
            left: `${left}px`,
            width: `${width}px`,
            height: `${frameHeight}px`,
          }}
        >
          <div
            className="absolute bottom-0 left-0 bg-gradient-to-b from-[rgba(200,237,3,0.3)] to-[rgba(200,237,3,0)] border-t-2 border-[#c8ed03]"
            style={{
              width: `${width}px`,
              height: `${height}px`,
            }}
          />
        </div>
      )})}
    </div>
  )
}

export const TotalOrdersCard: React.FC<TotalOrdersCardProps> = ({
  totalOrders,
  loading = false,
  monthlyAvg,
  label = 'Total Orders',
}) => {
  return (
    <StatsCard
      icon={<BarChart3 className="h-4 w-4" strokeWidth={1.8} />}
      iconAlt="Total Orders"
      label={label}
      value={formatCompactNumber(totalOrders)}
      loading={loading}
      mobileHeight="h-[126px]"
      chart={<TotalOrdersMiniBarChart monthlyAvg={monthlyAvg} seed={totalOrders} />}
    />
  )
}
